import React from 'react';

const Privacy = () => {
  return (
    <div className="max-w-3xl mx-auto py-8 px-4 space-y-6 text-gray-900 bg-white">
      <h1 className="text-3xl font-bold text-center">سیاست حفظ حریم خصوصی</h1>
      <p>با تشکر از اینکه از اپلیکیشن درمووایز استفاده می‌کنید. این سیاست حفظ حریم خصوصی توضیح می‌دهد که چه داده‌هایی جمع‌آوری می‌شود، چگونه استفاده می‌شود و حقوق شما به عنوان کاربر چیست.</p>

      <h2 className="text-2xl font-semibold">1. اطلاعات جمع‌آوری‌شده</h2>
      <ul className="list-disc list-inside space-y-2">
        <li><strong>اطلاعات حساب کاربری</strong>: ایمیل، نام کاربری و رمزعبور (رمزعبورها بصورت هش‌شده ذخیره می‌شوند).</li>
        <li><strong>اطلاعات آنالیز پوست</strong>: تصاویر و نتایج آنالیز (تصاویر فقط برای پردازش و در سرورهای ایمن ذخیره می‌شوند).</li>
        <li><strong>داده‌های رفتاری</strong>: پس از رضایت شما با Microsoft Clarity، رفتار صفحات و کلیک‌ها ضبط می‌شود.</li>
      </ul>

      <h2 className="text-2xl font-semibold">2. استفاده از داده‌ها</h2>
      <p>داده‌های جمع‌آوری‌شده برای ارائه خدمات اصلی (لاگین، آنالیز پوست)، بهبود تجربه کاربری و ارسال اعلان‌های مرتبط استفاده می‌شود.</p>

      <h2 className="text-2xl font-semibold">3. کوکی‌ها و تکنولوژی‌های مشابه</h2>
      <p>کوکی‌های ضروری و انتخابی (برای تحلیل رفتار) با رضایت شما استفاده می‌شوند. می‌توانید کوکی‌ها را از طریق تنظیمات مرورگر مدیریت کنید.</p>

      <h2 className="text-2xl font-semibold">4. اشتراک‌گذاری اطلاعات</h2>
      <p>اطلاعات شما فقط با سرویس‌های مورد نیاز (Firebase و Microsoft Clarity پس از دریافت رضایت) به اشتراک گذاشته می‌شود.</p>

      <h2 className="text-2xl font-semibold">5. امنیت داده‌ها</h2>
      <p>ما از HTTPS، رمزنگاری و روش‌های امنیتی استاندارد برای محافظت از داده‌های شما استفاده می‌کنیم.</p>

      <h2 className="text-2xl font-semibold">6. حقوق شما</h2>
      <p>شما می‌توانید هر زمان به داده‌های خود دسترسی داشته باشید، آن‌ها را اصلاح یا حذف کنید. برای این کار با پشتیبانی تماس بگیرید.</p>

      <h2 className="text-2xl font-semibold">7. تماس با ما</h2>
      <p>برای سوالات یا درخواست‌ها ایمیل بفرستید به <a href="mailto:support@dermowise.com" className="text-black underline">support@dermowise.com</a>.</p>

      <h2 className="text-2xl font-semibold">8. به‌روزرسانی سیاست</h2>
      <p>این سیاست ممکن است به‌روزرسانی شود. تاریخ آخرین بروزرسانی در بالای صفحه نمایش داده می‌شود.</p>

      <p className="text-gray-500 text-sm">آخرین به‌روزرسانی: 1 فروردین 1403</p>
    </div>
  );
};

export default Privacy; 